// # helpers
import angularRedux from '@/angular/angularRedux';
// # store
import store from '@/store';

(function (angular) {
    'use strict';

    angular.module('app')
        .controller('adminController', adminController);

    adminController.$inject = [
        '$rootScope',
        'thisUser',
        'Users',
        'navLinks',
        'TreeManager',
        'Browser'
    ];

    function adminController(
        $rootScope,
        thisUser,
        Users,
        navLinks,
        TreeManager,
        Browser
    ) {
        var vm = this;

        // properties
        vm.showHeaderDropdown = false;

        // methods
        vm.manageAccount = manageAccount;
        vm.toggleMobileMenu = toggleMobileMenu;

        /**
         * Shows manage account modal for this user, then updates rootScope
         * @return {void}
         */
        function manageAccount() {
            Users.edit($rootScope.thisUser.id)
                .result.then(function (updatedUser) {
                    angular.extend($rootScope.thisUser, updatedUser);
                });
        }

        /**
         * Shows / hides the navigation on mobile devices
         * @return {void}
         */
        function toggleMobileMenu() {
            vm.showMobileMenu = !vm.showMobileMenu;
        }

        /**
         * Init
         */
        (function () {
            Browser.addClasses();

            // Add user to rootscope
            if (thisUser) {
                $rootScope.thisUser = angular.extend({}, thisUser, {
                    isAdmin: (thisUser && thisUser.role === 'admin'),
                    isContributor: (thisUser && thisUser.role === 'contributor'),
                });

                store.dispatch({
                    type: 'UPDATE_USER',
                    payload: {
                        user: thisUser,
                    },
                });
            }

            // build navigation tree
            vm.navLinksTree = TreeManager.arrayToTree(navLinks);


            // Add array for holding requests with suppressed alerts
            $rootScope.suppressedRequests = [];

            new angularRedux($rootScope).enableSync();
        }());
    }
}(angular));
